/**
 * *****************************************************************************
 * *****************************************************************************
 * IMPORTANT: You must need jquery before you start using this directive.
 * *****************************************************************************
 * *****************************************************************************
 * @param {Object} data
 */
angular.module('App.ajax.service',[])
    /**
     * Used for getting campaigns based on the value of the filters.
     * @param {Object} $http
     */
    .factory('makeAjaxCall',['$http', '$rootScope', '$window', function($http, $rootScope, $window){
        //Serialize Array
        var serializeArray = function(arr, name, result){
            result = result || [];
            if(arr.length === 0){
                result.push({name:name, value:''});
            }else{
                angular.forEach(arr, function(value){
                    result.push({name:name, value:value});
                });
            }
            return result;
        };


        //Serialize Object
        var serializeObject = function(obj){
            var result = [];
            angular.forEach(obj, function(value, key){
                if(angular.isArray(value)){
                    serializeArray(value, key, result);
                } else if (angular.isObject(value) && !angular.isArray(value)) {
                    serializeObject(value);
                } else {
                    result.push({name:key, value:value});
                }
            });
            return result;
        };
        /**
         * IMPORTANT
         * @param: "args" must have following properties.
         * "url":(required) the url where the ajax call be posted.
         * "ajaxtype":(required) for analtyics purpose, it should be any unique name.
         * "requestType":(optional) GET,POST, PUT, DELETE. By default it does a GET
         *
         */
        return function( args ){
            if(typeof args === 'undefined' || typeof args.url === 'undefined' || typeof args.ajaxtype === 'undefined'){
                try{
                    console.log('One or more required fields are not present.');
                }catch(e){ }
                return;
            }
            var _httpObject = { };
            var noTransform = false;

            _httpObject.headers = args.headers || {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'};

            var _requestParam = 'params';
            _httpObject.method = args.requestType ? args.requestType: 'GET';
            if( _httpObject.method != 'GET'){
                _requestParam = 'data';
            }

            if (_httpObject.method === 'GET') {
                //Issue for IE. It caches all the get requests. Timestamp will be used for some kind of cache busting
                args.ts = new Date().getTime();
            }

            _httpObject.url = args.url;

            //check the cache if you need to cache it for subsequent calls.
            _httpObject.cache = args.cache||false;
            //analytics - Disabling temporarily till we move to Pendo for event tracking.
            // if(typeof ga != "undefined"){
            //     if(typeof JV == 'undefined'){
            //         var JV = {};
            //         //This is going to happen for cases when there is no JV.PAGE_TYPE set. This will be a problem after
            //         //Internationalization but better than having anything else.
            //         JV.PAGE_TYPE = $window.document.title;
            //     }
            //     //PB: Invoke GAService instead in jv.ga.service.js.
            //     if((typeof(_jvselfUser) !== "undefined")){
            //         ga('send', 'event', JV.PAGE_TYPE, args.ajaxtype, _jvselfUser.companyEId);
            //     }

            // }

            if (args.noTransform) {
                noTransform = args.noTransform;
                delete args.noTransform;
            }

            if(args.transformResponse && args.ajaxtype === 'postRegistrationUserDetails'){
				_httpObject.transformResponse = args.transformResponse;
            }
            
            //delete the properties which are not required for the post.
            var removeProperties = ['url','requestType','ajaxtype','cache', 'headers'];
            for( var i=0; i< removeProperties.length; i++){
                delete args[removeProperties[i]];
            }

            //VA: seems like we removed these lines with the changes, which caused video to break in the candidate details page as we were sending undefined values to the backend.
            // which were causing TypeMismatch exceptions.
            angular.forEach(args, function(value, key){
                 if(value==undefined){
                     delete args[key];
                 }
             });

            if(!noTransform && _httpObject.headers['Content-Type'] === 'application/x-www-form-urlencoded; charset=UTF-8' && angular.isDefined(args) && _httpObject.method !== 'GET') {
                //jquery $.param
                if (angular.isString(args)) {
                    args=JSON.parse(args);
                }
                if (args.traditional) {
                    delete args.traditional;
                    args = $.param(args, true);
                } else if (args.serializeObject){
                    delete args.serializeObject;
                    args = $.param(serializeObject(args));
                } else {
                    args = $.param(args);
                }
            }

            if (args.passAsStringParam && _httpObject.method !== 'GET') {
                delete args.passAsStringParam;
                args = args.data;
            }

            _httpObject[_requestParam]  = args;
            var promise = $http(_httpObject);
            return promise;
        };
    }]);
